var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function ($r, Aedu) {
buf.push("<div id=\"notifications\"><div class=\"notification-popover\"><div class=\"js-notification-list-location\"></div></div>");
if ( Aedu.serviceAvailability.serviceEnabled("notifications_db"))
{
buf.push("<a" + (jade.attr("href", $r.notifications_url(), true, true)) + " class=\"view_all_notifications text-primary\">View All Notifications</a>");
}
buf.push("</div>");}.call(this,"$r" in locals_for_with?locals_for_with.$r:typeof $r!=="undefined"?$r:undefined,"Aedu" in locals_for_with?locals_for_with.Aedu:typeof Aedu!=="undefined"?Aedu:undefined));;return buf.join("");
}